<template>
    <div class="wechat-response">
        <div class="table-box">
            <div class="top">
                <div class="input-box">
                    <el-input placeholder="规则名称" v-model="name" size="small"></el-input>
                </div>
                <div class="input-box">
                    <el-input placeholder="关键词" v-model="keyword" size="small"></el-input>
                </div>
                <div class="button-box">
                    <el-button size="small" type="primary" @click="search">查询</el-button>
                    <el-button size="small" type="primary" @click="addResponse">新增</el-button>
                </div>
            </div>
            <cc-table
                    :config="tableConfig"
                    :params="tableParams"
                    :refesh-params="refeshTable"
            >
            </cc-table>
        </div>
        <el-dialog
                title="编辑规则"
                :visible.sync="createShow"
                width="30%"
                append-to-body
        >
            <el-form ref="form" :model="form" v-loading="formLoaing" label-width="100px">
                <el-form-item label="名称">
                    <el-input v-model="form.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="关键词">
                    <el-input v-model="form.keyword" placeholder="请输入关键词"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.matchType" placeholder="请选择匹配类型">
                        <el-option label="精准匹配" value="0"></el-option>
                        <el-option label="模糊匹配" value="1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="回复类型">
                    <el-radio-group v-model="form.msgtype">
                        <el-radio label="text">文字</el-radio>
                        <el-radio label="news">图文</el-radio>
                        <el-radio label="image">图片</el-radio>
                    </el-radio-group>
                </el-form-item>

                <template v-if="form.msgtype == 'news'">
                    <el-form-item label="简介">
                        <el-input v-model="form.content" placeholder="请输入回复文字"></el-input>
                    </el-form-item>
                    <el-form-item label="跳转链接">
                        <el-input v-model="form.url" placeholder="请输入跳转链接"></el-input>
                    </el-form-item>
                    <el-form-item label="图片">
                        <cc-uploader :config="uploaderConf2"
                                     :useSuccess="true"
                                     @upload-success="uploadTrue2"
                                     v-if="!form.filePath"
                        />
                        <div class="image-box" v-else :style="`background: url(${form.filePath}) no-repeat center / cover`" @click="showImage">
                            <div class="del-image flex-between" @click.stop="delImage">X</div>
                        </div>
                    </el-form-item>
                </template>

                <template v-if="form.msgtype == 'text'">
                    <el-form-item label="文字">
                        <el-input v-model="form.content" placeholder="请输入回复文字"></el-input>
                    </el-form-item>
                </template>
                <template v-if="form.msgtype == 'image'">
                    <el-form-item label="图片">
                        <cc-uploader :config="uploaderConf2"
                                     :useSuccess="true"
                                     @upload-success="uploadTrue2"
                                     v-if="!form.filePath"
                        />
                        <div class="image-box" v-else :style="`background: url(${form.filePath}) no-repeat center / cover`" @click="showImage">
                            <div class="del-image flex-between" @click.stop="delImage">X</div>
                        </div>
                    </el-form-item>
                </template>

                <div class="save flex-between">
                    <el-button @click="createShow = false" style="margin-right: 20px">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-form>

        </el-dialog>
        <el-dialog
                :visible.sync="showImageDialog"
                width="80%"
                append-to-body
        >
            <img :src="form.filePath" style="display: block; margin: 0 auto;" alt="">
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "WechatResponse",
        data(){
            return {
                showImageDialog: false,
                uploaderConf2: this.$uploadUtils.config,
                createShow: false, //控制弹窗
                formLoaing: false, //控制表单加载动画
                name: "", //用于搜索 规则名称 条件
                keyword: "", // 用于搜索 关键词 条件
                //表格配置
                tableConfig: {
                    api: "wechat/mp/wxMpMessage/query",
                    showPager: true,
                    columns: [
                        {
                            prop: "id",
                            lable: "ID",
                            type: "input",
                        },
                        {
                            prop: "name",
                            lable: "规则名称",
                            type: "input",
                        },
                        {
                            prop: "matchtype",
                            lable: "类型",
                            type: "input",
                            render: function(row) {
                                return ["精准匹配", "模糊匹配"][row.matchtype]
                            }
                        },
                        {
                            prop: "keyword",
                            lable: "关键词",
                            type: "input",
                        },
                        {
                            prop: "msgtype",
                            lable: "回复类型",
                            type: "input",
                            render: function(row) {
                                let data = {
                                    text: "文字",
                                    news: "图文",
                                    image: "图片"
                                }
                                return data[row.msgtype]
                            }
                        },
                        {
                            prop: "createTime",
                            lable: "创建时间",
                            type: "date",
                        },
                        {
                            prop: "updateTime",
                            lable: "修改时间时间",
                            type: "date",
                        },
                    ],
                    buttons: [
                        {
                            name: "编辑",
                            click: row => {
                                this.editResponse(row)
                            }
                        },
                        {
                            name: "删除",
                            click: row => {
                                this.delResponse(row)
                            }
                        }
                    ],
                },
                refeshTable: -1, //控制表格 reload
                tableParams: { //表格请求传参
                    type: 1,
                },
                form: { //表单数据
                    name: "",
                    keyword: "",
                    matchType: "0",
                    msgtype: "text",
                    content: "",
                    url: "",
                    type: 1,
                },
                isEdit: false, //判断当前保存是否为编辑某条数据s
            }
        },
        methods: {
            showImage(){
                this.showImageDialog = true;
            },
            delImage(){
                this.form.filePath = false;
            },
            uploadTrue2(res){
                console.log(res)
                let data = {
                    ...this.form,
                    filePath: res.accessoryUrl,
                    mediaType: "image",
                    fileType: res.fileName.split('.')[1],
                    // content: ""
                }
                this.form = data;
            },
            showDialog(){
                this.createShow = true;
            },
            //添加数据
            addResponse() {
                this.form = {
                    name: "",
                    keyword: "",
                    matchType: "0",
                    msgtype: "text",
                    content: "",
                    type: 1,
                }
                this.showDialog();
            },
            //编辑数据
            editResponse(item){
                for(let i in item){
                    // console.log(i);
                    if(this.form[i] !== undefined || i === 'id'){
                        console.log(this.form[i])
                        this.form[i] = item[i]
                    }
                    if(i === "imgurl"){
                        this.form.filePath = item[i]
                    }
                }
                this.isEdit = true;
                this.showDialog();
            },
            //删除数据
            delResponse(item){
                let data = {
                    id: item.id
                };
                this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.ccRequest.do("wechat/mp/wxMpMessage/delete", data, "GET").then(() => {
                        this.refeshTable = new Date().getTime();
                        this.$message({
                            message: "删除成功",
                            type: "warning"
                        });
                    })
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },
            //搜索
            search(){
                this.tableParams = {
                    type: 1,
                    name: this.name,
                    keyword: this.keyword
                }
            },
            //表单保存操作
            save() {
                let data = this.form;
                let text = "添加成功";
                if(this.isEdit){ //编辑的时候修改提示
                    text = "编辑成功";
                }
                this.formLoaing = true;
                // this.createShow = false;
                this.ccRequest.do("wechat/mp/wxMpMessage/fosberMp/save", data, "POSTJSON").then(() => {
                    this.refeshTable = new Date().getTime();
                    this.formLoaing = false;
                    this.isEdit = false;
                    this.createShow = false;
                    this.$message({
                        message: text,
                        type: "success"
                    });
                }).catch(res=>{
                    this.formLoaing = false;
                    // this.$message.error(res.response.data.message);
                })

            },
        }
    }
</script>

<style scoped lang="scss">
    .wechat-response{
        background: #ffffff;
        .table-box{
            .top{
                display: flex;
                padding: 15px 20px;
            }
            .input-box{
                &:first-child{
                    margin-right: 10px;
                }
            }
            .button-box{
                margin-left: 25px;
            }
        }
        .save {
            margin-top: 20px;
            justify-content: center;
        }
    }
    .image-box{
        width: 100px;
        height: 100px;
        border: 1px solid #eeeeee;
        position: relative;
        cursor: pointer;
        .del-image{
            position: absolute;
            border-radius: 50%;
            border: 1px solid #f00;
            color: #f00;
            width: 20px;
            height: 20px;
            justify-content: center;
            text-align: center;
            right: 0;
            top: 0;
            transform: translateY(-50%) translateX(50%);
        }
    }
</style>
